<template>
  <form class="card rounded-top" @submit.prevent="save">
    <div class="row card-body">
      <div class="form-group col-6">
        <w-input :model="$schema.code" :title="$t($schema.code.$schema.title)" />
      </div>

      <div class="form-group col-6">
        <w-input :model="$schema.value" :title="$t($schema.value.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-select placeholder="Wybierz grupę ustawień..." :model="$schema.groupId" :values="groups" :title="$t($schema.groupId.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-textarea :model="$schema.description" :title="$t($schema.description.$schema.title)" />
      </div>

      <div class="col-12 text-right card-actions">
        <button class="btn btn-dark btn-lg rounded-pill" @click.prevent="cancel">
          {{ $t('buttons.cancel') }}
        </button>

        <button type="submit" class="btn btn-smart btn-lg rounded-pill">{{ $t('buttons.save') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';

import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/setting.schema';

const emptyData = () => ({
  code: '',
  description: '',
  value: '',
  valueType: '',
  groupId: null
});

const messages = {
  added: 'messages.setting.added',
  addError: 'messages.setting.addError',
  formError: 'messages.setting.formError',
  updated: 'messages.setting.formError',
  updateError: 'messages.setting.updateError'
};

// @vuese
// Formularz ustawienia
// @group Setting
export default {
  name: 'SettingForm',
  schema,
  mixins: [formViewMixin('setting', messages, emptyData)],
  computed: {
    buttonText() {
      return this.edit ? 'buttons.save' : 'buttons.add';
    },
    ...mapState({
      groups: state => state.setting.group.list.map(group => ({ value: group.id, text: group.name })),
      stateData: state => {
        const setting = state.setting.data;
        setting.groupId = setting.group ? setting.group.id : null;
        return setting;
      }
    })
  }
};
</script>
